import { Outlet } from "react-router-dom";

const PaymentsParentPage = () => {
    return <Outlet />
}
export default PaymentsParentPage;